export default __webpack_public_path__ + "static/media/330_portfolio04-fr-web.45e9e7b6.png";